import React from 'react'
import { Link } from 'react-router-dom'
import { formatDate } from '../../utils/helpers'

/**
 * Footer component with responsive design and useful links
 * Adapts layout for different screen sizes
 */
const Footer = () => {
  const currentYear = formatDate(new Date(), 'yyyy')

  return (
    <footer className="bg-gray-800 text-white">
      <div className="container mx-auto px-4 py-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="col-span-1 md:col-span-2">
            <div className="">
              <img 
                src="https://startup-tnt-documents.tor1.digitaloceanspaces.com/public/startuptnt-logo.png" 
                alt="Startup TNT" 
                className="h-auto w-40"
              />
            </div>
            <h3 className="text-lg font-semibold mb-4">Angel Vault</h3>
            <p className="text-gray-300 text-sm leading-relaxed">
              Your trusted platform for angel investing and portfolio management. 
              Connect with innovative startups and build your investment portfolio.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-md font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <a 
                  href="https://startuptnt.com/about-tnt" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-gray-300 hover:text-white transition-colors"
                >
                  About Us
                </a>
              </li>
              <li>
                <a 
                  href="https://startuptnt.com/contact" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-gray-300 hover:text-white transition-colors"
                >
                  Contact
                </a>
              </li>
              {/* <li>
                <Link to="/help" className="text-gray-300 hover:text-white transition-colors">
                  Help Center
                </Link>
              </li> */}
            </ul>
          </div>

          {/* Legal */}
          {/* <div>
            <h4 className="text-md font-semibold mb-4">Legal</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/privacy" className="text-gray-300 hover:text-white transition-colors">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/terms" className="text-gray-300 hover:text-white transition-colors">
                  Terms of Service
                </Link>
              </li>
              <li>
                <Link to="/disclaimer" className="text-gray-300 hover:text-white transition-colors">
                  Disclaimer
                </Link>
              </li>
            </ul>
          </div> */}
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-700 mt-8 pt-8 text-center">
          <p className="text-gray-400 text-sm">
            © {currentYear} Startup TNT. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  )
}

export default Footer
